//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormField from "@/models/FormField";
import User from "@/models/User";
import { TEXT_INPUT, CHECKBOX } from "@/models/FormField";
import isMobile from "~/mixins/isMobile.js";

export default {
  mixins: [isMobile],
  props: {
    title: {
      required: true,
    },
    subtitle: {
      required: true,
    },
    cta: {
      required: false,
      default: "Log In",
    },
    emailExists: {
      required: false,
      default: false,
    },
    showDocumentShareInfo: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      submission: {
        email: "",
        password: "",
      },
      error: null,
      submitting: false,
      fields: [
        new FormField({
          field_type: TEXT_INPUT,
          name: "email",
          label: "Email",
          placeholder: "john@doe.com",
          validation: { required: true },
          meta: { autocomplete: "email", hs_el: "account.login.email" },
        }),
        new FormField({
          field_type: TEXT_INPUT,
          name: "password",
          label: "Password",
          placeholder: "Password",
          validation: { required: true },
          meta: { autocomplete: "password", hs_el: "account.login.password" },
        }),
      ],
    };
  },

  methods: {
    handleSubmit() {
      if (this.submitting) return;
      this.submitting = true;
      User.login(this.submission)
        .then(() => {
          this.$emit("success");
        })
        .catch(({ response }) => {
          if (response.status == 303 && response.data.message) {
            this.error = response.data.message;
          } else {
            this.error = "Login failed, something went wrong!";
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    updateData(newValue) {
      this.submission = newValue;
      this.error = null;
    },
  },
};
